import { Shard } from '@/components/Shard'
import { getPseudoRandomShardList } from '@/components/Pixelator/shards'
import { cn } from '@/utilities/ui'

export const HorizontalRuleShards = ({ className }: { className?: string }) => {
  const shards = getPseudoRandomShardList(5)
  return (
    <div className={cn('flex flex-row gap-[30px] items-center justify-center', className)}>
      <hr className="flex-1 border-rock-1 my-0" />
      <div className="flex flex-row gap-[30px] items-center justify-center">
        {shards.map((shard, i) => (
          <div key={i} className="scale-50">
            <Shard shard={shard} />
          </div>
        ))}
      </div>
      <hr className="flex-1 border-rock-1 my-0" />
    </div>
  )
}
